import React from 'react';
import PropTypes from 'prop-types';
import { TAX_RATE } from 'constants/billingPackage/calculationConstants';

const PriceBreakdown = ({ basePrice, duration, discount }) => {
  function roundHalfUp(num) {
    return Math.sign(num) * Math.round(Math.abs(num));
  }

  const subtotal = basePrice * duration;
  const discountAmount = roundHalfUp((subtotal * discount) / 100);
  const totalPrice = subtotal - discountAmount;
  const taxAmount = roundHalfUp((totalPrice * TAX_RATE) / 100);
  const afterTaxTotal = roundHalfUp(totalPrice + taxAmount);

  return (
    <div
      style={{
        padding: '1em',
        backgroundColor: '#f8f9fa',
        borderRadius: '4px',
        marginTop: '1em',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '0.5em',
          color: '#666',
        }}
      >
        <span>Subtotal ({duration} months)</span>
        <span>Rp{subtotal.toLocaleString('id-ID')}</span>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '0.5em',
          color: '#666',
        }}
      >
        <span>Discount ({discount}%)</span>
        <span style={{ color: '#e74c3c' }}>
          - Rp{discountAmount.toLocaleString('id-ID')}
        </span>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingTop: '0.5em',
          borderTop: '1px solid #ddd',
          marginBottom: '0.5em',
          color: '#666',
        }}
      >
        <span>Subtotal</span>
        <span>Rp{totalPrice.toLocaleString('id-ID')}</span>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '0.5em',
          color: '#666',
        }}
      >
        <span>Tax ({TAX_RATE}%)</span>
        <span>Rp{taxAmount.toLocaleString('id-ID')}</span>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingTop: '0.5em',
          borderTop: '1px solid #ddd',
          fontWeight: 'bold',
          fontSize: '1.1em',
        }}
      >
        <span>Total (after tax)</span>
        <span>Rp{afterTaxTotal.toLocaleString('id-ID')}</span>
      </div>
    </div>
  );
};

PriceBreakdown.propTypes = {
  basePrice: PropTypes.number.isRequired,
  duration: PropTypes.number.isRequired,
  discount: PropTypes.number.isRequired,
};

export default PriceBreakdown;
